import { Trans, useTranslation } from 'react-i18next';
import Link from '@mui/material/Link';
import { Link as RouterLink } from 'react-router';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Helmet from 'react-helmet';
import { TextV2 } from '@insights-ltd/design-library/components';
import SelfServiceLayout from 'components/layout/SelfServiceLayout';
import { FormData } from 'pages/ForgottenPassword/types';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';
import { styled } from '@mui/material';
import MailSentIcon from 'components/Svgs/ASSET-PaperPlane.svg';

const StyledH1 = styled(TextV2)({
  textAlign: 'center',
});

const StyledP = styled(TextV2)({
  textAlign: 'center',
});

type ConfirmationProps = FormData & {
  backUrl: string;
};

const Confirmation = ({ emailAddress, backUrl }: ConfirmationProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('ui.event-management.title.forgotten-password')}</title>
      </Helmet>
      <SelfServiceLayout>
        <Card
          sx={(theme) => ({
            maxWidth: '31rem',
            padding: `0 ${theme.spacing(spacingSizeMap.XS)}`,
          })}
        >
          <CardContent>
            <Grid
              container
              sx={{
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Grid size={12}>
                <TextV2>
                  <img
                    alt={t('ui.event-management.title.forgotten-password')}
                    src={MailSentIcon}
                  />
                </TextV2>
              </Grid>
              <Grid
                sx={(theme) => ({
                  flexBasis: 'auto',
                  width: '100%',
                  margin: `${theme.spacing(spacingSizeMap.XS)} 0`,
                })}
                size={12}
              >
                <StyledH1 component="h1" variant="h3">
                  {t(
                    'ui.event-management.forgotten-password-confirmation.heading',
                  )}
                </StyledH1>
                <StyledP variant="body1" color="textSecondary">
                  <Trans
                    i18nKey="ui.event-management.forgotten-password-confirmation.sub-heading.bold"
                    values={{ emailAddress }}
                    components={{
                      bold: <TextV2 component="span" variant="bodyBold" />,
                    }}
                  />
                </StyledP>
              </Grid>
              <Grid size={12}>
                <TextV2 variant="bodyBold">
                  <Link component={RouterLink} to={backUrl}>
                    {t(
                      'ui.event-management.forgotten-password-confirmation.back',
                    )}
                  </Link>
                </TextV2>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </SelfServiceLayout>
    </>
  );
};

export default Confirmation;
